import { TransactionArgument, Transaction } from '@mysten/sui/transactions'
import { normalizeSuiObjectId } from '@mysten/sui/utils'
import {VAULTS_CONFIG} from "../../constant";
import {handleMessageError, VaultsErrorCode} from "../../errors";
export class VoloUtils {
  static requestStakeCoin(tx: Transaction, sui_coin: TransactionArgument) {
    const volo = VAULTS_CONFIG.config.volo
    if (volo === undefined) {
      return handleMessageError(VaultsErrorCode.StakeProtocolNotFound, 'the volo config is undefined')
    }

    tx = tx || new Transaction()
    const { native_pool, vsui_metadata } = volo.config
    const ha_sui_coin = tx.moveCall({
      target: `${volo.published_at}::native_pool::stake_non_entry`,
      typeArguments: [],
      arguments: [tx.object(native_pool), tx.object(vsui_metadata), tx.object(normalizeSuiObjectId('0x5')), sui_coin],
    })
    return ha_sui_coin
  }
}
